$(document).ready(function() {
    // Load saved pincode
    var Existing_pin = localStorage.getItem('ExistPincode');
    if (Existing_pin) {
        $('#pincode_1').val(Existing_pin);
        // Auto check if already saved
        checkPincode(Existing_pin);
    }

    // On keyup (real-time check)
    $('#pincode_1').keyup(function() {
        const pincode = $(this).val().trim();

        if (pincode.length !== 6 || isNaN(pincode)) {
            $('#responsemessage').text('Please enter valid 6 digit Pincode').removeClass('success').addClass('error');
            return;
        }

        checkPincode(pincode);
    });

    // Main function
    function checkPincode(pincode) {
        const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;

        $.ajax({
            url: apiUrl,
            method: 'GET',
            dataType: 'json',
            success: function(response) {
                if (response.success && 
                    response.data && 
                    response.data.data && 
                    Array.isArray(response.data.data.available_courier_companies) && 
                    response.data.data.available_courier_companies.length > 0) {

                    // Servicable hai
                    const firstCourier = response.data.data.available_courier_companies[0];
                    const estDays = parseInt(firstCourier.estimated_delivery_days || 1, 10);

                    localStorage.setItem('ExistPincode', pincode);
                    localStorage.setItem('TAT', estDays);

                    getDeliveryData(estDays);

                } else {
                    // Not servicable
                    $('#responsemessage').html('Pincode Not Servicable').removeClass('success').addClass('error');
                }
            },
            error: function() {
                $('#responsemessage').html('Error fetching delivery info. Please try again.').removeClass('success').addClass('error');
            }
        });
    }

    // Date calculation function
    function getDeliveryData(days) {
        const next_dt = new Date();
        next_dt.setDate(next_dt.getDate() + days);

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        const monthName = monthNames[next_dt.getMonth()];
        const dayName = dayNames[next_dt.getDay()];
        const date = next_dt.getDate();

        $('#responsemessage').html(
            `<span class="span2"><u>Free Delivery:</u> <b>${dayName}, ${monthName} ${date}</b></span>`
        ).removeClass('error').addClass('success');
    }
});